export default "__VITE_ASSET__CyZdZMVg__"